// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".overlay-wrapper[data-v-3b967a58]{display:flex;align-items:center;justify-content:center;height:100%}.overlay-wrapper .overlay-content[data-v-3b967a58]{width:80%;height:300px;border-radius:5px;overflow-y:scroll;background-color:#fff}", ""]);
// Exports
module.exports = exports;
